import React, { useState } from "react";
import { Modal } from "react-blueprint-library";
import LostDataModal from "../../../../../../../SharedComponents/LostDataModal";

import "./AddNewChargeModal.scss";

const AddNewChargeModal = ({
  showAddNewChargeModal,
  setShowAddNewChargeModal,
  isUpdates,
  children,
}) => {
  const [showLDModal, setShowLDModal] = useState(false);

  const handleCloseBackModal = () => {
    setShowLDModal(false);
    setShowAddNewChargeModal(true);
  };

  const handleShowBackModal = () => {
    if (isUpdates) {
      setShowLDModal(true);
    } else {
      setShowAddNewChargeModal(false);
    }
  };

  const handleBackClick = () => {
    handleCloseBackModal();
    setShowAddNewChargeModal(false);
  };

  return (
    <div className="drp-add-new-charge-wrapper">
      <Modal
        show={showAddNewChargeModal}
        className={`modal-md drp-add-new-charge-modal-wrapper ${showLDModal ? "hide-modal" : ""}`}
        title=""
        id="add-new-charge-modal"
      >
        <div className="col-md-1 drp-modal-header-wrapper">
          <h2 id="new-charge-text">Add New Charge</h2>
          <button
            id="add-new-charge-modal-close"
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close modal dialog"
            onClick={handleShowBackModal}
          />
        </div>
        <div className="req-field">
          <span id="required-text">* = Required Field</span>
        </div>
        <div className="req-field-sub">
          <span id="complete-text">Complete every field for each charge.</span>
        </div>

        <div className="children-container">
          {React.cloneElement(children, {
            setShowLDModal: setShowLDModal,
          })}
        </div>
      </Modal>

      <LostDataModal
        isOpen={showLDModal}
        handleClose={handleCloseBackModal}
        handleProceed={handleBackClick}
      />
    </div>
  );
};

export default AddNewChargeModal;
